import { ClipLoader, MoonLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector } from "@stores/slices/userSlice";
import { isWebview, clickAccountButtonNative } from "@utils/webview.util";
interface Props {
  selectedQty: number;
  onQtyChange: (qty: number) => void;
  isWishlist: boolean;
  onUpdateWishList: (isWishlist: boolean) => void;
  onAddtoCart: (qty: number) => void;
  isLoading: boolean;
  isWishlistLoading: boolean;
  isSaleable: boolean;
}

const AddButtonSet = ({
  selectedQty,
  onQtyChange,
  isWishlist,
  onUpdateWishList,
  onAddtoCart,
  isLoading,
  isWishlistLoading,
  isSaleable,
}: Props) => {
  const spinnerColorCode = "#f23030";
  const isAuthenticated = useSelector(isAuthenticatedSelector);

  return (
    <div className="cart-extra">
      <div className="cart-product-quantity">
        <div className="quantity">
          <input
            type="button"
            defaultValue="-"
            className="minus"
            onClick={() => onQtyChange(-1)}
          />
          <input
            type="number"
            name="quantity"
            title="Qty"
            className="qty"
            size={4}
            placeholder={selectedQty.toString()}
            readOnly
          />
          <input
            type="button"
            defaultValue="+"
            className="plus"
            onClick={() => onQtyChange(1)}
          />
        </div>
      </div>
      <button
        className="btn btn-cart flex-grow-1"
        onClick={() => {
          onAddtoCart(selectedQty);
          if (isWebview() && !isAuthenticated) {
            clickAccountButtonNative();
          }
        }}
        disabled={isLoading || !isSaleable}
      >
        {!isSaleable ? "สินค้าหมด" : "เพิ่มลงรถเข็น"}
      </button>
      {isWishlistLoading ? (
        <div style={{ marginLeft: "4%", marginTop: "4%" }}>
          <MoonLoader
            color={spinnerColorCode}
            loading={isWishlistLoading}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <a
          className="btn btn-wishlist p-0 d-none d-lg-grid"
          onClick={() => onUpdateWishList(!isWishlist)}
        >
          <i className={`icon icon-heart ${isWishlist && "active"}`} />
        </a>
      )}
    </div>
  );
};

export default AddButtonSet;
